import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=4a747d73"
import script from "./Error.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Error.vue?vue&type=script&charset=utf-8&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports